import { useCallback } from 'react';
import globalFilterService from '@/core/services/GlobalFilterService';

export interface EncodeFilterResponse {
  status: string;
  code: number;
  data: string;
  request_parameters: {
    account_id: string;
    universe_id: string;
    data: string;
  };
}

export function useFilterEncode() {
  const encodeFilter = useCallback(async (payload: Record<string, unknown>): Promise<string> => {
    const encoded = await globalFilterService.encode(payload);
    return encoded.data;
  }, []);

  const encodeFilterWithResponse = useCallback(async (payload: Record<string, unknown>): Promise<EncodeFilterResponse> => {
    const encoded = await globalFilterService.encode(payload);
    return encoded as EncodeFilterResponse;
  }, []);

  return { encodeFilter, encodeFilterWithResponse };
}
